import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getFormValues } from 'redux-form'
import {
  signIn,
  signInSpotify,
  setRoleToUser,
  getCuratorRank,
  checkUserEmailToSignIn,
  setLoginTypeToInitialState,
} from 'Redux/actions/auth'
import { updatePlaylists } from 'Redux/actions/playListsActions'
import { getIsArtist, getAuthType } from 'Redux/selectors/auth'
import { sendQuickLoginLink } from 'Redux/actions/usersActions'
import Component from './Login'

const selector = createStructuredSelector({
  formStates: state => getFormValues('log_in_form')(state),
  isArtist: getIsArtist,
  authType: getAuthType,
})

const actions = {
  onSignIn: signIn,
  onSignInSpotify: signInSpotify,
  setRoleToUser,
  getCuratorRank,
  updatePlaylists,
  checkUserEmailToSignIn,
  setLoginTypeToInitialState,
  sendQuickLoginLink,
}

export default connect(selector, actions)(Component)
